import { COUPON, PROMO_CODE, QUALIFIERS } from 'contexts/CruiseSearchContext/constants';

import { forEach, includes } from 'lib/helpers';

import { getPromoCodeApplied } from './getPromoCodeApplied';

export const validateTargetedOfferToApply = ({ query, newTargetedOfferState, enableDisabledPromotionMessage }) => {
	let promoCodeApplied = {};
	let qualifiers = {};
	let disabledPromoMessage = {};
	let isDisabledPromo = false;

	if (includes(query[QUALIFIERS], COUPON)) {
		forEach(query[QUALIFIERS].split('|'), (item) => {
			const prop = item.split(':');
			qualifiers[prop[0]] = prop[1];
		});
	}

	const targetedOffers = newTargetedOfferState?.data?.targetedOffers || [];
	promoCodeApplied = getPromoCodeApplied({
		qualifiers,
		query,
		targetedOffers,
	});

	const appliedPromoCode = qualifiers[COUPON] || query[PROMO_CODE];

	if (enableDisabledPromotionMessage?.couponCodePrefix?.length && !Object.keys(promoCodeApplied).length && appliedPromoCode) {
		isDisabledPromo = enableDisabledPromotionMessage?.couponCodePrefix.some((promoCode) => appliedPromoCode.indexOf(promoCode) === 0);

		if (isDisabledPromo) {
			disabledPromoMessage = enableDisabledPromotionMessage?.message;
			promoCodeApplied = {};
		}
	}

	const isInvalidPromo =
		!newTargetedOfferState.isValid ||
		!Object.keys(promoCodeApplied).length ||
		!newTargetedOfferState?.data?.targetedOffers?.length ||
		isDisabledPromo;

	return {
		isInvalidPromo,
		qualifiers,
		promoCodeApplied,
		disabledPromoMessage,
	};
};
